import { Theme } from '@/theme';
import styled, { css } from 'styled-components';
import type { Size } from './Tiles';

export const ContentGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  padding: 0 15px;
  width: 100%;
  box-sizing: border-box;
  margin-bottom: 18px;

  > a[data-size='large'] {
    grid-column: 1 / -1;
  }
`;

export const Tile = styled.a<{ $size: Size }>`
  border-radius: 24px;
  padding: ${Theme.rems(15)};
  display: flex;
  text-decoration: none;
  box-sizing: border-box;
  min-width: 0;

  img {
    object-fit: contain;
  }

  ${props => {
    switch (props.$size) {
      case 'small':
        return css`
          width: 100%;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          text-align: center;
          gap: ${Theme.rems(6)};
          min-height: 160px;

          figure {
            width: 70px;
            height: auto;
            margin: 0 0 4px 0;
          }
          
          h3 {
            font-size: ${Theme.rems(20)};
            line-height: ${Theme.rems(17)};
          }
        `
      case 'medium':
        return css`
          width: 100%;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          text-align: center;
          gap: ${Theme.rems(6)};
          min-height: 160px;

          figure {
            width: 70px;
            height: auto;
            margin: 0 0 4px 0;
          }
          
          h3 {
            font-size: ${Theme.rems(20)};
            line-height: ${Theme.rems(17)};
          }
        `
      case 'large':
        return css`
          width: 100%;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
          text-align: left;
          min-height: 140px;
          gap: ${Theme.rems(12)};

          figure {
            max-width: 177px;
            height: 116px;
            order: 2;
            display: flex;
            flex-direction: column;
            justify-content: center;
            margin: 0;
          }

          article {
            order: 1;
            flex: 1;
            display: flex;
            flex-direction: column;
            gap: ${Theme.rems(6)};
          }
          
          h3 {
            font-size: ${Theme.rems(35)};
            line-height: ${Theme.rems(28)};
          }
        `
    }
  }}

  h3 {
    color: ${Theme.color.white};
    letter-spacing: 0.2px;
    font-weight: 700;
    text-transform: uppercase;
  }

  p {
    font-size: ${Theme.rems(12)};
    color: ${Theme.color.white};
    line-height: ${Theme.rems(12)};
  }
`;
